export default "__VITE_ASSET__CnM4Y5AG__"